import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import "../styles/modal.css";
import CancelIcon from "@mui/icons-material/Cancel";

const FailureModal = (props) => {
  const { modal, setModal, message, onDelete } = props;

  const customStyles = {
    top: "30%",
    left: "35%",
    right: "auto",
    bottom: "auto",
    backgroundColor: "#ffff",
    borderRadius: "8px",
    width: "30%",
    height: "204px",
    padding: "30px",
    zIndex: 9000000000000,
    position: "absolute",
    fontFamily: "Inter",
    display: "flex",
    flexDirection: "column",
  };

  return (
    <div>
      <Modal
        open={modal}
        onClose={() => setModal("none")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={customStyles}>
          <Typography
            component="div"
            variant="h4"
            sx={{
              color: "#000000",
              fontSize: "24px",
              fontWeight: "bold",
              fontFamily: "Inter",
              fontWeight: 600,
              textShadow:"12px 12px 48px 0px rgba(80, 80, 159, 0.04)"
            }}
          >
            Delete
          </Typography>
          <Typography
            component="p"
            variant="p"
            style={{ marginTop: "12px", color: "#5C6674", fontSize: "14px" }}
          >
            Are you sure you want to delete? This action cannot be undone.
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "12px",
            }}
          >
            <Button
              onClick={() => {
                setModal(false);
              }}
              sx={{
                color: "#0869FB",
                textTransform: "capitalize",
                marginRight: "10px",
              }}
            >
              No
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#0869FB", textTransform: "capitalize" }}
              onClick={() => {
                onDelete();
                setModal(false);
              }}
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default FailureModal;
